//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class SubmittingEntityListModel extends ModelBase {
      static readonly $typeName = 'SubmittingEntityListModel';
      public key: string;
      public allowedDataSetsCommaSeperated: string;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/SubmittingEntityListModel.ts